import React from 'react';
import styles from './ProfitScore.module.css';
import { ScoreTrend } from '../routesTypes';

interface ProfitScoreProps {
  score: number;
  trend: ScoreTrend;
}

export const ProfitScore: React.FC<ProfitScoreProps> = ({ score, trend }) => {
  const isHigh = score >= 70;

  return (
    <span className={`${styles.score} ${isHigh ? styles.high : styles.low}`}>
      {score}
      {trend === 'up' ? (
        <svg className={styles.arrow} viewBox="0 0 16 16" fill="currentColor">
          <path d="M8 4l4 4H9v4H7V8H4l4-4z"/>
        </svg>
      ) : (
        <svg className={styles.arrow} viewBox="0 0 16 16" fill="currentColor">
          <path d="M8 12l-4-4h3V4h2v4h3l-4 4z"/>
        </svg>
      )}
    </span>
  );
};
